import {JurisdicaoLocalListaComponent} from './jurisdicao-local-lista/jurisdicao-local-lista.component';
import {NgModule} from '@angular/core';
import {AppSharedModule} from '../app-shared.module';
import {ComponentsModule} from '../components/components.module';
import {JurisdicaoLocalService} from './jurisdicao-local.service';
import {JurisdicaoLocalRoutingModule} from './jurisdicao-local.routing';
import { JurisdicaoLocalVisualizacaoComponent } from './jurisdicao-local-visualizacao/jurisdicao-local-visualizacao.component';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule,
  ],
  declarations: [
    JurisdicaoLocalListaComponent,
    JurisdicaoLocalVisualizacaoComponent
  ],
  exports: [
    JurisdicaoLocalRoutingModule,
    JurisdicaoLocalListaComponent
  ],
  providers: [
    JurisdicaoLocalService
  ]
})
export class JurisdicaoLocalModule { }
